<script setup>
import { WdsButtonPrimary } from '@wds/components';

const { t } = useI18n();

const { useUrl } = useUrls();
const { isMobileOrTablet } = useDevice();

const testingStore = useTestingStore();
const { $tracking } = useNuxtApp();

const bfData = testingStore.getFeatureVariables('web_blackFriday');

const bfProperties = computed(() => {
  return bfData?.homepage?.properties || [];
});

// METHODS
function getUrlToBlackFriday(termsAndConditionsKey) {
  const termsAndConditionsUrl = termsAndConditionsKey === 1 ? '#terms-and-conditions' : '';
  return `${useUrl.getStaticBaseURL()}deals/black-friday/${termsAndConditionsUrl}`;
}
function handleTermsAndConditionsClick() {
  $tracking.triggerCampaignBannerEventAction({ action: 'Black Friday T&C Clicked' });
}
function handleAllDealsClick() {
  $tracking.triggerCampaignBannerEventAction({ action: 'Black Friday All Deals Clicked' });
}
function handlePropertyCardClick(property, index) {
  $tracking.triggerCampaignBannerEventAction({
    action: 'Black Friday Carousel Clicked',
    bf_property_clicked: property?.propertyId,
    bf_offer_displayed: property?.tag,
    bf_carousel_position_clicked: index + 1,
  });
}
</script>

<template>
  <div
    v-if="bfProperties?.length"
    class="bf-banner"
  >
    <h2>Black Friday</h2>
    <p class="text">
      <span>{{ $t('t_BFLPHERO1') }}</span>
      <a
        :href="getUrlToBlackFriday(1)"
        class="tclink"
        rel="noopener"
        :target="isMobileOrTablet ? '_self' : '_blank'"
        @click="handleTermsAndConditionsClick"
      >{{ $t('t_TCAPPLY') }}</a>
    </p>
    <PromotionsHwPopularDealsCards
      :properties="bfProperties"
      @property-click="handlePropertyCardClick"
    />
    <WdsButtonPrimary
      :href="getUrlToBlackFriday(0)"
      :text="t('t_DISCOVERALLDEALS')"
      :title="t('t_DISCOVERALLDEALS')"
      :aria-label="t('t_DISCOVERALLDEALS')"
      :reversed="true"
      rel="noopener"
      :target="isMobileOrTablet ? '_self' : '_blank'"
      icon-end="arrow-right"
      class="bf-view-all"
      @click="handleAllDealsClick"
    />
  </div>
</template>

<style lang="scss" scoped>
.bf-banner {
  display: flex;
  flex-direction: column;
  gap: $wds-spacing-s;
  background-image: url('https://a.hwstatic.com/image/upload/f_auto,q_auto,w_750,c_fill,g_auto/v1787311501/campaign/2026/BlackFriday_Glitch.jpg');
  background-repeat: no-repeat;
  background-position: left center;
  background-size: cover;
  min-height: wds-rem(510px);
  border-radius: $wds-spacing-m;
  padding: $wds-spacing-l 0;
  margin-bottom: $wds-spacing-xxl;
  line-height: $wds-line-height-body-2;

  h2 {
    @include title-3-bld;

    background-color: $wds-color-pink;
    color: $wds-color-white;
    overflow-wrap: break-word;
    text-align: center;
    width: fit-content;
    clip-path: polygon(0 0, 100% 0, calc(100% - 4px) 100%, 0 100%);
    padding: $wds-spacing-xs $wds-spacing-l;
  }

  .text {
    @include body-2-bld;

    color: $wds-color-white;
    z-index: 1;
    display: inline;
    width: fit-content;
    padding-inline: $wds-spacing-l;

    .tclink {
      color: $wds-color-white;
      text-decoration: underline;
      cursor: pointer;
      padding: $wds-spacing-s;

      &:focus-within,
      &:focus,
      &:focus-visible,
      &:active {
        border-radius: $wds-spacing-s;
        box-shadow:
          wds-rem(1px) 0 0 wds-rem(1px) $wds-color-white,
          wds-rem(-1px) 0 0 wds-rem(1px) $wds-color-white,
          wds-rem(1px) 0 0 wds-rem(2px) $wds-color-ink-darker,
          wds-rem(-1px) 0 0 wds-rem(2px) $wds-color-ink-darker;
      }
    }
  }

  .bf-view-all {
    width: calc(100% - 2 * $wds-spacing-l);
    align-self: center;
  }

  @include tablet {
    background-image: url('https://a.hwstatic.com/image/upload/f_auto,q_auto,w_1440,c_fill,g_auto/v1787311501/campaign/2026/BlackFriday_Glitch.jpg');
  }

  @include desktop {
    h2 {
      @include title-1-bld;
    }

    .bf-view-all {
      width: fit-content;
      margin-right: $wds-spacing-l;
      align-self: flex-end;
    }
  }
}
</style>
